import { LESSONS, COURSE_LABEL, COURSE_ACCENT, CourseSlug } from "@/data/lessons";

export function findLesson(courseSlug: CourseSlug, order: string) {
  const lesson = LESSONS[courseSlug].find((l) => l.order === order)!;
  return {
    lesson,
    course: COURSE_LABEL[courseSlug],
    courseSlug,
    accent: COURSE_ACCENT[courseSlug],
  };
}
